import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

type Props = {
  modalStatus: boolean;
  closeModal: () => void;
};

const ModalWelcome: React.FC<Props> = ({ modalStatus, closeModal }) => {
  return (
    <Modal
      isOpen={modalStatus}
      onRequestClose={closeModal}
      contentLabel="Welcome Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="animated fadeInDown faster modal-welcome"
    >
      <div className="modal-description text-center welcome-modal-content">
        <h2>CHÀO MỪNG HLV MỚI</h2>
        <div className="welcome-text">
          Chào mừng bạn gia nhập sân cỏ FC Online! Hãy hoàn thành các nhiệm vụ tại mục "Chào bạn mới, đón bạn cũ" để nhận các phần quà dành riêng cho tân thủ và trọn bộ ưu đãi tiếp sức tựu trường.
        </div>
      </div>
      <a href="#" onClick={(e) => { e.preventDefault(); closeModal(); }} className="close" data-dismiss="modal" aria-label="Close">
        ×
      </a>
    </Modal>
  );
};

export default ModalWelcome;
